import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { VideozapisiService } from './videozapisi.service';
import { Video } from './videozapis';
import { Subject } from 'rxjs';
import * as toastr from 'toastr';

@Component({
  selector: 'app-videozapisi',
  templateUrl: './videozapisi.component.html',
  styleUrls: ['./videozapisi.component.css'],
  providers: [VideozapisiService]
})
export class VideozapisiComponent implements OnInit {

  sviVideozapisi: Video[] = [];
  videoOptions: DataTables.Settings = {};
  videoTrigger: Subject<Video> = new Subject();

  videozapisForma: FormGroup;
  videozapisEditForma: FormGroup;

  videoId: string;

  constructor(
    private _fb: FormBuilder,
    private _videozapisiService: VideozapisiService
  ) { }

  ngOnInit() {
     this.dohvati();
     //Tablica početak
     this.videoOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      responsive: true,
      columnDefs: [{
          targets: 'no-sort',
          orderable: false
      }],
      retrieve: true
  };
  //Tablica kraj
    this.videozapisForma = this._fb.group({
      naziv: [''],
      link: [''],
    });
    this.videozapisEditForma = this._fb.group({
      naziv: [''],
      link: [''],
    });
  }

  pripremiPodatke(video){
    // console.log(video);
    this.videoId = video['id'];
    this.videozapisEditForma = this._fb.group({
      naziv: video['naziv'],
      link: video['link']
    });
  }

  uredi(video){
    let podaciZaSlanje = {
      'id': this.videoId,
      'naziv': video['naziv'],
      'link': video['link'],
      'access_token': localStorage.getItem('tokenMongo')
    }
    // console.log(podaciZaSlanje);
    this._videozapisiService.urediVideo(podaciZaSlanje).subscribe(res => {
      // console.log(res);
      if(res['createdAt']){
        toastr.success("Uspješno uređivanje!");
        this.dohvati();
      } else {
         toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  spremi(videozapisForma){
    // console.log(videozapisForma);
    if(videozapisForma['naziv'] && videozapisForma['link']){
      this._videozapisiService.dodajVideo(videozapisForma).subscribe(res => {
        if(res['createdAt']){
          toastr.success("Uspješno dodan video!");
          this.dohvati();
          // this.sviVideozapisi.push({
          //   'id': '',
          //   'naziv': videozapisForma['naziv'],
          //   'link': videozapisForma['link']
          // });
        } else {
           toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
       toastr.error("Unesite potrebne podatke!");
    }
  }

  dohvati(){
    this.sviVideozapisi = [];
    this._videozapisiService.dohvatiSve().subscribe(res => {
      // console.log(res);
      if(res.length > 0){
        for(let i = 0; i < res.length; i++){
          this.sviVideozapisi.push({
            'id': res[i]['id'],
            'naziv': res[i]['naziv'],
            'link': res[i]['link']
          });
        }
        this.videoTrigger.next();
      } else {
         toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/vimeo/videozapisi/videozapisi.component.ts